#import "~/graphql/fragments/sections/default/baseEntryFields.graphql"
#import "~/graphql/fragments/assets/image.graphql"

fragment globalQuoteSection on globalQuote_Entry
{
    ... baseEntryFields
    label
    externalUrl
}
